enum SceneKeys {
  Preloader = 'preloader',
  StartScreen = 'start-screen',
  Game = 'game',
  GameOver = 'game-over',
  HighScores = 'high-scores',
}

export default SceneKeys
